import { Pin, BadgeCheck } from "lucide-react";
import Linkified from "@/components/community/Linkified";
import Attachment from "@/components/community/Attachment";
import MessageActions from "@/components/community/MessageActions";

const when = (iso) => new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });

export default function MessageItem({ api, msg, me, act, compact }) {
  return (
    <article className={`group px-2 py-2.5 flex gap-3 hover:bg-[#101010] transition-colors ${msg.mine ? "border-l-2 border-[#FFD600]/60" : "border-l-2 border-transparent"}`}
      data-testid={`community-msg-${msg.id}`}>
      <div className={`w-9 h-9 shrink-0 flex items-center justify-center font-heading font-black text-sm ${msg.author_is_team ? "bg-[#FFD600] text-black" : "bg-[#1F1F1F] text-white"}`}>
        {(msg.author_first || "?")[0].toUpperCase()}
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-baseline gap-x-2 text-sm">
          <span className="font-semibold" data-testid={`community-msg-author-${msg.id}`}>{msg.author_first}</span>
          <span className="text-muted-foreground text-xs inline-flex items-center gap-1">
            {msg.author_is_team && <BadgeCheck size={12} className="text-[#FFD600]" />}{msg.author_business}
          </span>
          <span className="text-[11px] text-muted-foreground">{when(msg.created_at)}</span>
          {msg.pinned && <span className="text-[10px] font-mono-label text-[#FFD600] inline-flex items-center gap-1" data-testid={`community-msg-pinned-${msg.id}`}><Pin size={10} /> PINNED</span>}
        </div>
        {msg.text && <Linkified text={msg.text} className="text-sm mt-0.5 whitespace-pre-wrap break-words" testid={`community-msg-text-${msg.id}`} />}
        {msg.attachment && <Attachment api={api} url={`/community/files/${msg.id}`} att={msg.attachment} testid={`community-msg-${msg.id}`} />}
      </div>
      {!compact && <MessageActions msg={msg} me={me} act={act} api={api} />}
    </article>
  );
}
